<template>
  <div class="CAOpenDoor">
    <div>
      <div class="icon el-icon-circle-check-outline"></div>
      <div class="name">已经为您打开编号为：<span>{{boxId}}号箱格</span></div>
      <div class="tips" v-if="project_type=='1'">请尽快打开箱格，记得随手关门</div>
      <div class="tips" v-else>请在5秒内开门，否则将自动关闭</div>
      <div class="tips mt20" v-if="isOverTips = true">{{time2}}秒后若箱门未关，系统将自动开始盘点</div>
    </div>
    <!-- <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" :topic2="topic2" :msg2="msg2" :isSend="isSend" ref="mqttws" @getMessage="getMessage"></mqttws> -->
    <currtime :isShowInfo="true"></currtime>
    <netWork :isNetWork="isNetWork"></netWork>
    <template v-if="isError == true">
      <div class="tipDio">
        <div class="name">未在规定时间内打开箱格</div>
        <div class="name">请重新操作</div>
        <div class="tips"><b>{{time}}秒</b></div>
        <div class="backbtn"><el-button @click="backUp">返回</el-button></div>
      </div>
      <div class="bgDiv"></div>
    </template>
  </div>
</template>

<script>
import currtime from '../../../../assets/currTime'
import netWork from '../../../../assets/netWork'
import mqttws from '../../../../assets/mqttws'
import { checkData } from '../../../../../static/js/utils/util.js'
import { text2Audio,storage,conLog,getMp3 } from '../../../../../static/js/utils/utility.js'
import * as config from '../../../../../static/js/config.js';
import again2Mp3 from '../../../../../static/mp3/longtime.mp3'
import openTip1 from '../../../../../static/mp3/openTip1.mp3'
import openTip2 from '../../../../../static/mp3/openTip2.mp3'
import {websocketsend} from  '../../../../../static/js/utils/socket.js'
export default {
  name: 'CAOpenDoor',
  data () {
    return {
      boxId:'',

      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response',
      msg:'',
      isConnect:true,//是否默认订阅

      topic2:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol',
      msg2:'',
      isSend:true,

      isError:false,//未拉开门弹窗
      time:3,
      timeStatus:'',

      time2:120,
      timeStatus2:'',
      isOverTips:false,

      overtime:30,//超时
      overtimeStatus:'',//超时状态

      project_type:'',

      overopen:5,//开门超时
      overopenStatus:'',//开门超时状态
      // errorOpen: 0,//开门失败次数

      isNetWork:true,

      openStatus:false,//是否有开过门

      sendMsg:'',
    }
  },
  mounted(){

  },
  created(){
    var that = this
    var configStorage = JSON.parse(localStorage.getItem('configStorage'))
    if(configStorage){
      this.project_type = configStorage.unmanShow
    }
    this.boxId = this.$route.query.boxId
    var boxId =this.$route.query.boxId

    this.sendMsg = 'd704'+boxId+','
    websocketsend(this.sendMsg);

    // var errorOpen = storage.localGetItem('errorOpen')
    // if(errorOpen){
    //   this.errorOpen = errorOpen
    // }

    // this.overOpen(this.overopen)
    
    if(that.project_type == '1'){
      var msg = 'a5551505160101010000000101d6060001'+boxId;
      var num = checkData(msg)
      msg = msg+num
      that.msg2 = msg
      
    }else if(that.project_type == '2'){
      var msg2 = 'a5551505160101010000000101d7040001'+boxId;
      var num = checkData(msg2)
      msg2 = msg2+num
      that.msg2 = msg2
    }
    
  },
  components:{
    mqttws,
    currtime,
    netWork,
  },
  methods:{
    openTip2Fun(){
      var url = openTip2
      var audio = new Audio(url);
      audio.src = url;
      audio.play();
    },
    //接收socket
    getSkMsg(res){
      var that = this;
      this.isNetWork = false
      if(res){
        if(res.meta && res.meta.code == 300){
          that.$message.error('订单已满，无法开门')
          that.backUp()
          return
        }
        if(res.fun_code == 'd704'){
          for(var i in res.cells){
            if(parseInt(that.boxId) == res.cells[i].cell_id){
              if(res.cells[i].lock_status == '2'){
                // that.errorOpen = 0
                //text2Audio('已经为您打开'+that.boxId+'号箱格，请尽快打开箱格，记得随手关门')
                var url = openTip1
                var audio = new Audio(url);
                audio.src = url;
                audio.play();
                audio.addEventListener('ended', function () {
                  getMp3(that.boxId,() =>{
                    that.openTip2Fun()
                  })
                }, false);
                clearTimeout(that.overopenStatus)
                that.getSecond2(that.time2)
                that.isOverTips = true
              }else if(res.cells[i].lock_status == '1'){
                  //开门失败
                  // text2Audio('未在规定时间内打开箱格，请重新操作')
                  that.isError = true
                  var url = '../../../../../static/mp3/again2.mp3'
                  var audio = new Audio(url);
                  audio.src = url;
                  audio.play();
                  that.getSecond(that.time)
              }
            }
          }
        }else if(res.fun_code == 'E501'){
          for(var i in res.cells){
            if(parseInt(that.boxId) == res.cells[i].cell_id){
              if(res.cells[i].lock_status == '1'){
                //关门
                clearTimeout(that.timeStatus2)
                that.$router.push({
                  path:'/toolCabinet/CAdmin/CAInventory',
                  query:{
                    boxId:that.boxId
                  }
                })
              }
            }
          }
        }
      }
    },
    //开门超时
    overOpen(wait){
      conLog('CAopenoverOpen',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.overopenStatus)
        
        if(that.errorOpen >= 3){
          that.backUp()
        }else{
          that.errorOpen += 1
          that.overopen = 5
          that.overOpen(that.overopen)
          var topic2 = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
          if(that.project_type == '1'){
            var msg = 'a5551505160101010000000101d6060001'+that.boxId;
            // console.log(msg)
            var num = checkData(msg)
            msg = msg+num
            that.$refs.mqttws.send(topic2,msg)
          }else if(that.project_type == '2'){
            var msg2 = 'a5551505160101010000000101d7040001'+that.boxId;
            var num = checkData(msg2)
            msg2 = msg2+num
            that.$refs.mqttws.send(topic2,msg2)
          }
          
        }
        
      } else {
        this.overopen=wait
        wait--;
        that.overopenStatus = setTimeout(function() {
          that.overOpen(wait);
        },1000);
      }
    },
    //接收mqtt信息
    getMessage(data){
      var that = this;
      this.isNetWork = false
      if(data){
        var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
        var num = checkData(str)
        var bbc = data.substr(data.length-2)
        // var lastTwo = str.substring(str.length-6,str.length-4)
        var id = str.substring(str.length-4,str.length)
        var type = str.substring(26,30)
        // if(lastTwo == 55 && num == bbc){
        // if(num == bbc && type == 'd606'){
        //   that.errorOpen = 0
        //   clearTimeout(that.overopenStatus)
        //   //是否开门
        //   var lastTwo = str.substring(str.length-2,str.length)
        //   if(lastTwo == 55){
        //     that.overTime(that.overtime);
        //     var topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
        //     that.$refs.mqttws.onConnect(topic)
        //     text2Audio('已经为您打开'+that.boxId+'号箱格，请尽快打开箱格，记得随手关门')
        //   }else{
        //     that.isError = true
        //     text2Audio('箱格门未正常打开，请重新操作')
        //     that.getSecond(that.time)
        //   }
        // }else if(num == bbc && type == 'd704'){
        //   that.errorOpen = 0
        //   clearTimeout(that.overopenStatus)
        //   //是否开门
        //   var lastTwo = str.substring(str.length-2,str.length)
        //   if(lastTwo == 55){
        //     that.overTime(that.overtime);
        //     var topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
        //     that.$refs.mqttws.onConnect(topic)
        //     text2Audio('已经为您打开'+that.boxId+'号箱格，请尽快打开箱格，记得随手关门')
        //   }else{
        //     that.isError = true
            // text2Audio('箱格门未正常打开，请重新操作')
            // // var url = '../../../../../static/mp3/again2.mp3'
            // // var audio = new Audio(url);
            // // audio.src = url;
            // // audio.play();
        //     that.getSecond(that.time)
        //   }
        // }else if(num == bbc && type == 'df0f'){
        //   //是否真正开门
        //   clearTimeout(that.overtimeStatus)
        //   var lastTwo = str.substring(str.length-2,str.length)
        //   if(lastTwo == 55){
        //     // var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
        //     // var msg = 'A5551505160101010000000101D6040001'+that.boxId
        //     // var num = checkData(msg)
        //     // msg = msg+num
        //     // this.$refs.mqttws.send(topic,msg)
        //     // this.$refs.mqttws.disconnect()
        //     // that.$router.push({
        //     //   path:'/toolCabinet/CBorrow/CInventory',
        //     //   query:{
        //     //     boxId:that.boxId
        //     //   }
        //     // })
        //     that.getSecond2(that.time2)
        //     that.isOverTips = true
        //   }else{
        //     that.isError = true
        //     // text2Audio('未在规定时间内打开箱格，请重新操作')
            // var url = again2Mp3
            // var audio = new Audio(url);
            // audio.src = url;
            // audio.play();
        //     that.getSecond(that.time)
        //   }
        // }else if(num == bbc && type == 'd705'){
        //   //是否真正开门
        //   clearTimeout(that.overtimeStatus)
        //   var lastTwo = str.substring(str.length-2,str.length)
        //   if(lastTwo == 55){
        //     that.getSecond2(that.time2)
        //     that.isOverTips = true
        //   }else{
        //     that.isError = true
        //     // text2Audio('未在规定时间内打开箱格，请重新操作')
        //     var url = again2Mp3
        //     var audio = new Audio(url);
        //     audio.src = url;
        //     audio.play();
        //     that.getSecond(that.time)
        //   }
        // }else 
        if(num == bbc && type == 'df10'){
          //是否关门
          var lastTwo = str.substring(str.length-2,str.length)
          if(lastTwo == 'aa'){

            clearTimeout(that.timeStatus2)

            // that.$refs.mqttws.disconnect()
            that.$router.push({
              path:'/toolCabinet/CAdmin/CAInventory',
              query:{
                boxId:that.boxId
              }
            })
          }else{
            clearTimeout(that.timeStatus2)
            // that.$refs.mqttws.disconnect()
            that.$router.push({
              path:'/toolCabinet/CAdmin/CAInventory',
              query:{
                boxId:that.boxId
              }
            })
          }
        }else if(num == bbc && type == 'd706'){
          //是否关门
          var lastTwo = str.substring(str.length-2,str.length)
          if(lastTwo == 'aa'){
            
            clearTimeout(that.timeStatus2)

            // that.$refs.mqttws.disconnect()
            that.$router.push({
              path:'/toolCabinet/CAdmin/CAInventory',
              query:{
                boxId:that.boxId
              }
            })
          }else{

            clearTimeout(that.timeStatus2)

            // that.$refs.mqttws.disconnect()
            that.$router.push({
              path:'/toolCabinet/CAdmin/CAInventory',
              query:{
                boxId:that.boxId
              }
            })
          }
        }
      }
    },
    //倒计时
    getSecond2(wait){
      conLog('CAopengetSecond2',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(this.timeStatus2)
        // this.$refs.mqttws.disconnect()
        that.$message.error('系统开始自动盘点，盘点结果可能不准确~ ')
        setTimeout(function(){
          that.$router.push({
            path:'/toolCabinet/CAdmin/CAInventory',
            query:{
              boxId:that.boxId
            }
          })
        },3000)
      } else {
        this.time2=wait
        wait--;
        that.timeStatus2 = setTimeout(function() {
          that.getSecond2(wait);
        },1000);
      }
    },
    //倒计时
    getSecond(wait){
      conLog('CAopengetSecond',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.timeStatus)
        that.isError = false;
        that.backUp()
      } else {
        this.time=wait
        wait--;
        that.timeStatus = setTimeout(function() {
          that.getSecond(wait);
        },1000);
      }
    },
    //返回
    backUp(){
      // this.$refs.mqttws.disconnect()
      // var errorOpen = storage.localGetItem('errorOpen')
      // if(errorOpen){
      //   storage.localRemoveItem('errorOpen')
      // }
      this.$router.push({
        path:'/toolCabinet/CAdmin'
      })
    },
    //超时
    overTime(wait){
      conLog('CAopenoverTime',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.overtimeStatus)
        that.backUp()
      } else {
        this.overtime=wait
        wait--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(wait);
        },1000);
      }
    }
  },
  watch :{
    "$store.state.wsMsg":function(newVal){
      this.getSkMsg(newVal)
    }
  },
}
</script>

<style lang="less">
.CAOpenDoor{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  // background: url('../../../../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  .icon{
    color: #4babfe;
    font-size: 2rem;
  }
  .name{
    font-size: 0.5rem;
    margin: 0.8rem 0 0.27rem;
    span{color:#fff;}
  }
  .tips{
    font-size: 0.36rem;
    color: #e2dfdf;
  }
  .tipDio{
    width: 50%;
    position: fixed;
    top: 10%;
    left:50%;
    margin-left: -25%;
    background: #fff;
    color: #333;
    z-index: 100;
    border-radius: 0.1rem;
    .name{
      text-align: left;
      padding-left: 0.4rem;
      margin: 0.4rem 0;
    }
    .tips{
      font-size: 0.3rem;
    }
    .backbtn{
      text-align: right;
      margin: 0.2rem 0.4rem 0.4rem;
      .el-button{
        height: 0.94rem;
        width: 2.54rem;
        padding: 0;
        // margin: 0 1.2rem;
        font-size: 0.4rem;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
      }
    }
  }
  .bgDiv{
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 99;
    left: 0;
    right: 0;
    top: 0;
    bottom:0;
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CAdmin/CAOpenDoor.vue